import WatchComponentView from '../views/watch.view.html';

class WatchController {
    constructor($scope, $http, toast) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.toast = toast;

        this.saving = false;
    }

    $onInit() {
    }
}

let watchComponent = {
    bindings: {
        productId: '<',
        productUrl: '@',
        isWatched: '<'
    },
    template: WatchComponentView,
    controller: WatchController
};

export default watchComponent;
